import {Portals} from '@qwyk/models';
import {Observable} from 'rxjs';

export abstract class ShipmentTrackingServiceBase {
    public abstract getShipmentTrackingEvents(shipmentId: string): Observable<Portals.ShipmentTrackingEvent[]>;
}
